var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fe-flex fe-items-center fe-text-body-xxs fe-text-primary-grey-80 lg:fe-text-body-s"},[_c('JdsIcon',{attrs:{"name":"VerifiedIcon","smSize":"s","lgSize":"m","color":"fe-text-success-50","className":"fe-mr-xxs"}}),_c('div',[_vm._t("default",function(){return [_vm._v("Verified Purchase")]})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }